module.exports = __webpack_public_path__ + "static/media/thezappersband.a3f75ff9.png";